.headerContainer {
  align-items: center;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;
  padding: 10px 16px;
  background-color: white;

  .rightSideHeader {
    display: flex;
    gap: 16px;
  }

  .closeButton {
    display: flex;
    justify-content: end;
    width: 100%;
  }

  div {
    height: 40px;
  }

  .disableTile {
    cursor: not-allowed;
  }

  img {
    height: 20px;
    width: 20px;
  }

  // Icon-only controls (tile-view close, NLB info) keep their own hit box.
  .iconButton {
    cursor: pointer;
    padding: 10px 8px;

    &:hover {
      background-color: #f2f2f2;
      border-radius: 4px;
    }
  }

  // Labelled controls: icon + label as one target.
  .navButton {
    align-items: center;
    background-color: transparent;
    border: none;
    border-radius: 8px;
    // Explicit: OnboardingOverlay injects padding onto this element at runtime.
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    gap: 4px;
    // 40px keeps a usable touch target; the design box is the 20px content row.
    height: 40px;
    padding: 0 4px;

    &:hover {
      background-color: #f2f2f2;
    }
  }

  .navLabel {
    color: #1a1a23;
    font-family: "Montserrat Medium", sans-serif;
    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;
  }
}
